export default __webpack_public_path__ + "static/media/supreme.f9c84eae.png";